// Viser "3 stk. = 90,00 kr" under antalvælgeren på produktkort, når kunden vælger mere end 1.
// Serveren renderer den korrekte startværdi; her opdateres den med det samme når +/- trykkes,
// så kunden ikke skal vente på at kurven svarer.
(function () {
  // Snippet'et kan indlæse scriptet mere end én gang på en side med flere sektioner.
  if (window.cardLineTotalReady) return;
  window.cardLineTotalReady = true;

  function formatMoney(cents) {
    const amount = (cents / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return amount + ' kr';
  }

  function update(input) {
    const wrapper = input.closest('.card__quantity');
    if (!wrapper) return;

    const total = wrapper.querySelector('.card__line-total');
    if (!total) return;

    const quantity = parseInt(input.value, 10) || 0;
    if (quantity < 2) {
      total.hidden = true;
      wrapper.classList.remove('card__quantity--has-total');
      return;
    }

    const unitPrice = parseInt(total.dataset.unitPrice, 10) || 0;
    total.textContent = quantity + ' stk. = ' + formatMoney(quantity * unitPrice);
    total.hidden = false;
    wrapper.classList.add('card__quantity--has-total');
  }

  document.addEventListener('change', function (event) {
    if (event.target.classList && event.target.classList.contains('quantity__input')) {
      update(event.target);
    }
  });
})();
